import React, { useState, useEffect } from 'react'
import CardFull from '../components/card/full'
import styles from '../ResumenADN.module.css'
import Collapse from '../components/collapse'
import Subtitle from '../../../components/Subtitle/Subtitle'
import ProyeccionVida from '../components/proyeccion-vida'
import ProyeccionAP from '../components/proyeccion-ap'
import ProyeccionFU from '../components/proyeccion-fu/proyeccion-fu'
import * as Funciones from "../../../utils/funciones";
import * as Constantes from "../../../utils/constantes";

const Proyecciones = ({ productos, textosLegales }) => {
  const [openId, setOpenId] = useState('')

  const onTab = (id) => setOpenId(id)

  const tieneProyecciones = (producto) => {
    if(Funciones.tieneProyecciones(producto.codigoProducto)) {
      for(let escenario of producto.escenarios) {
        if(escenario.proyecciones !== null && escenario.proyecciones.length > 0) {
          return true
        }
      }
      return false
    } else {
      return false
    }
  }

  useEffect(() => {
    if (productos && productos.length > 0) {
      setOpenId(productos[0].codigoProducto)
    }
  }, [productos])

  return (
    <CardFull>
      <Subtitle sname="Proyecciones" mostrar="true"></Subtitle>
      <div className={styles.container__wrapper}>
        <div className={`${styles.descripCard} ${styles.descripCardFix}`}>
          Podrás evaluar como serán las proyecciones de los planes de seguro que ofrecemos
        </div>

        {productos !== undefined && productos.length > 0
          ? <React.Fragment>
            {productos.map((producto, index) => (
              tieneProyecciones(producto)
                ? <Collapse
                  key={'producto_' + index}
                  title={producto.descripcion}
                  id={producto.codigoProducto}
                  openTab={openId === producto.codigoProducto}
                  onTab={onTab}>
                    {/* PRODUCTO VIDA */}
                    {Constantes.COD_TIPO_PRODUCTO_VIDA_INVERSION === producto.codigoTipoProducto
                      ? <ProyeccionVida
                        producto={producto}
                        textosLegales={textosLegales}
                      />
                      : null
                    }
                    
                    {/* PRODUCTO ACCIDENTE PERSONALES */}
                    {Constantes.COD_TIPO_PRODUCTO_VIDA_TEMPORAL === producto.codigoTipoProducto ||
                      Constantes.COD_TIPO_PRODUCTO_ACCIDENTES_PERSONALES === producto.codigoTipoProducto ||
                      Constantes.COD_TIPO_PRODUCTO_VIDA_DEVOLUCION === producto.codigoTipoProducto
                      ? <ProyeccionAP
                          producto={producto}
                          textosLegales={textosLegales}
                        />
                      : null
                    }

                    {/* PRODUCTO FONDO UNIVERSITARIO */}
                    {Constantes.COD_TIPO_PRODUCTO_FONDO_UNIVERSITARIO === producto.codigoTipoProducto
                      ? <ProyeccionFU producto={producto}
                        textosLegales={textosLegales}
                      />
                      : null
                    }
                </Collapse>
                : null
            ))}
          </React.Fragment>
          : null
        }
      </div>
    </CardFull>
  )
}

export default Proyecciones
